<template>
  <div class="vida-auth-page">
    <div class="vida-auth-overlay">
      <div class="vida-login">
        <div class="vida-login-wrapper">
          <div class="vida-logo-box">
            <div class="vida-brand-name">Love Light</div>
            <div class="vida-login-caption">{{ $t('loginUi.memberWindow') }}</div>
          </div>

          <form class="vida-login-form" @submit.prevent="doLogin">
            <van-field
              v-model="username"
              class="vida-input"
              type="text"
              input-align="center"
              autocomplete="username"
              :placeholder="$t('login.usernamePls')"
            />
            <van-field
              v-model="password"
              class="vida-input"
              :type="passwordType"
              input-align="center"
              autocomplete="current-password"
              :placeholder="$t('login.passwordPls')"
              :right-icon="passwordType === 'password' ? 'closed-eye' : 'eye-o'"
              @click-right-icon="switchPasswordType"
            />

            <van-button class="vida-login-button" native-type="submit" type="primary">
              {{ $t('login.doLogin') }}
            </van-button>

            <div class="vida-login-links">
              <div @click="toRegister">
                <span>{{ $t('loginUi.noAccount') }} </span><span class="vida-sign-up">{{ $t('loginUi.signUpNow') }}</span>
              </div>
              <button type="button" class="vida-login-link" @click="toService"><span>{{ $t('loginUi.customerService') }}</span></button>
              <button type="button" class="vida-login-link" @click="toForgot"><span>{{ $t('loginUi.forgotPassword') }}</span></button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      passwordType: 'password'
    }
  },
  computed: {
    ...mapGetters(['isLoggedIn'])
  },
  methods: {
    ...mapActions(['login']),
    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    toRegister() {
      if (this.$route.path !== '/Register') this.$router.push('/Register')
    },
    async openSupport(reason) {
      let baseInfo = this.$store.getters.getBaseInfo || {}
      let serviceUrl = String(baseInfo.kefu || '').trim()

      if (!serviceUrl) {
        const response = await this.$http({ method: 'get', url: 'base_info' })
        if (response && (response.code === 200 || response.code === 0) && response.data) {
          baseInfo = response.data
          this.$store.commit('setBaseInfoValue', baseInfo)
          serviceUrl = String(baseInfo.kefu || '').trim()
        }
      }

      if (/^https?:\/\//i.test(serviceUrl)) {
        window.location.assign(serviceUrl)
        return
      }

      this.$router.push({ path: '/ServiceOnline', query: { reason } })
    },
    toService() {
      this.openSupport('customer-service').catch(() => {
        this.$router.push({ path: '/ServiceOnline', query: { reason: 'customer-service' } })
      })
    },
    toForgot() {
      this.openSupport('password-reset').catch(() => {
        this.$router.push({ path: '/ServiceOnline', query: { reason: 'password-reset' } })
      })
    },
    async doLogin() {
      if (!this.username.trim()) {
        this.$toast(this.$t('login.usernamePls'))
        return
      }
      if (!this.password.trim()) {
        this.$toast(this.$t('login.passwordPls'))
        return
      }

      try {
        const result = await this.login({
          username: this.username.trim(),
          password: this.password.trim()
        })
        this.$toast.success(result.msg)
        if (this.$route.path !== '/Mine') this.$router.push('/Mine')
      } catch (error) {
        this.$toast(error.message || this.$t('login.loginFailed'))
      }
    }
  },
  created() {
    if (this.isLoggedIn && this.$route.path === '/Login') this.$router.push('/Mine')
  },
  mounted() {
    this.$nextTick(() => {
      if (window.startLoginBackground) window.startLoginBackground()
    })
  },
  beforeDestroy() {
    if (window.stopLoginBackground) window.stopLoginBackground()
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/css/basenew.css";

.vida-auth-page {
  position: fixed;
  inset: 0;
  z-index: 1000;
  width: 100%;
  height: var(--app-height, 100vh);
  min-height: 0;
  overflow: hidden;
  background: transparent;
  font-size: 16PX;
  font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", Helvetica, "Segoe UI", Arial, Roboto, "PingFang SC", miui, "Hiragino Sans GB", "Microsoft Yahei", sans-serif;
}

.vida-auth-overlay {
  position: absolute;
  inset: 0;
}

.vida-auth-overlay {
  background: rgba(0, 0, 0, .51);
}

.vida-login {
  display: flex;
  height: 100%;
  flex-direction: column;
}

.vida-login,
.vida-logo-box,
.vida-login-caption,
.vida-login-form,
.vida-login-form input,
.vida-login-form button,
.vida-login-links {
  font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", Helvetica, "Segoe UI", Arial, Roboto, "PingFang SC", miui, "Hiragino Sans GB", "Microsoft Yahei", sans-serif;
}

.vida-login-wrapper {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior-y: contain;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-y;
  transform: translateY(-8vh);
}

@media screen and (max-height: 620px) {
  .vida-login-wrapper { justify-content: flex-start; padding-top:48px; padding-bottom:24px; transform:none; }
  .vida-brand-name { font-size:clamp(34px,10vw,48px); }
  .vida-login-caption { padding-top:12px; }
  .vida-login-form { padding-top:8px; }
  .vida-input { margin-top:14px; padding-top:11px; padding-bottom:11px; }
  .vida-login-button { height:46px; margin-top:24px; }
}

.vida-language {
  position: absolute;
  top: 1.333vw;
  right: 5.333vw;
  width: 5.7841vw;
  height: 8.267vw;
  line-height: 6.667vw;
  cursor: pointer;
}

.vida-language img {
  width: auto;
  height: 70%;
}

.vida-logo-box {
  text-align: center;
}

.vida-brand-name {
  color: #f4d49a;
  font-size: 10vw;
  font-weight: 700;
  letter-spacing: .08em;
  text-shadow: 0 3px 14px rgba(0, 0, 0, .6);
}

.vida-login-caption {
  padding-top: 4vw;
  color: #ccc;
}

.vida-login-form {
  padding: 2.667vw 8vw;
}

.vida-input {
  width: 100% !important;
  height: auto;
  box-sizing: border-box;
  margin-top: 5.333vw;
  padding: 3.467vw 2.667vw;
  border: .267vw solid #766350;
  border-radius: 1.333vw;
  color: #e6b98a;
  background: linear-gradient(120deg, #212121, #313131);
  font-size: 4vw;
  text-align: center;
}

.vida-login-button {
  width: 100%;
  height: 10.667vw;
  margin-top: 11.333vw;
  border: 0;
  border-radius: 6.667vw;
  color: #68302c;
  background: linear-gradient(#fde3ca, #e7b486);
  font-size: 4vw;
  font-weight: 700;
}

.vida-login-links {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 2.667vw;
  color: #e6b98a;
  font-size: 3.333vw;
}

.vida-login-links > div,
.vida-login-links > button {
  cursor: pointer;
}

.vida-login-link {
  padding: 0;
  border: 0;
  color: inherit;
  background: transparent;
  font: inherit;
}

.vida-sign-up {
  color: #f11616;
}

.vida-auth-page /deep/ .van-nav-bar__content {
  height: 13.333vw;
}

.vida-auth-page /deep/ .van-nav-bar__left,
.vida-auth-page /deep/ .van-nav-bar__right {
  padding: 0 2.133vw;
}

.vida-auth-page /deep/ .van-cell::after {
  display: none;
}

.vida-auth-page /deep/ .van-field__control {
  height: 4.7273vw;
  color: #e6b98a;
}

.vida-auth-page /deep/ .van-field__control::placeholder {
  color: #c8c9cc;
  opacity: 1;
}

.vida-auth-page /deep/ .van-field__right-icon {
  margin-right: -1.067vw;
  padding: 0 1.067vw;
}

.vida-auth-page /deep/ .van-field__right-icon .van-icon {
  color: #969799;
  font-size: 6.667vw;
}

@media screen and (min-width: 1024px) {
  .vida-auth-page {
    width: 430PX;
    right: auto;
    left: 50%;
    transform: translateX(-50%);
  }

  .vida-nav { height: 150PX; }
  .vida-auth-page /deep/ .van-nav-bar__content { height: 50PX; }
  .vida-login-wrapper { transform: translateY(-90PX); }
  .vida-language { height: 40PX; }
  .vida-language img { position: relative; top: -57PX; right: -30PX; }
  .vida-brand-name { font-size: 42PX; }
  .vida-login-caption { padding-top: 18PX; }
  .vida-login-form { padding: 10PX 20PX; }
  .vida-input {
    display: flex;
    align-items: center;
    height: 60PX;
    margin-top: 26PX;
    padding: 0 14PX;
    border-width: 1PX;
    border-radius: 8PX;
    font-size: 16PX;
  }
  .vida-login-button { height: 50PX; margin-top: 42PX; font-size: 16PX; }
  .vida-login-links { padding-top: 14PX; font-size: 14PX; }
  .vida-login-links > div,
  .vida-login-links > button { flex: 1; text-align: center; }
  .vida-auth-page /deep/ .van-field__body { width: 100%; }
  .vida-auth-page /deep/ .van-field__control { height: 24PX; line-height: 24PX; }
  .vida-auth-page /deep/ .van-field__right-icon .van-icon { font-size: 20PX; }
}
</style>

<style lang="less">
.vida-login-language-popover.van-popover {
  width: 96PX !important;
  max-height: none !important;
}

.vida-login-language-popover .van-popover__content {
  max-height: none !important;
  overflow: hidden !important;
  border-radius: 4PX !important;
}

.vida-login-language-popover .van-popover__action {
  width: 96PX !important;
  height: 29PX !important;
  padding: 0 6PX !important;
  font-size: 11PX !important;
  line-height: 29PX !important;
}

.vida-login-language-popover .van-popover__action-text {
  font-size: 11PX !important;
  line-height: 29PX !important;
  white-space: nowrap !important;
}

.vida-login-language-popover .van-popover__arrow {
  border-width: 6PX !important;
}
</style>
